<template>
  <SearchForm
    class="search-form-container"
    :theme="NAVI"
    :direct-stock-method="directStockMethod"
  />
</template>
<script>
import { NAVI } from '../../constants/desktop_autocomplete_theme'
import { WINDOW_LOCATION, VUE_ROUTER } from '../../constants/direct_method'

import SearchForm from './SearchForm.vue'

export default {
  name: 'ContainerNavi',
  components: {
    SearchForm,
  },
  props: {
    directStockMethod: {
      type: String,
      default: WINDOW_LOCATION,
      validator(value) {
        return [WINDOW_LOCATION, VUE_ROUTER].includes(value)
      },
    },
  },
  data() {
    return {
      NAVI,
    }
  },
}
</script>
<style scoped lang="scss">
.search-form-container {
  position: relative;
  width: 320px;
  margin: 10px 0px 0px 12px;
  padding: 0px;
  background-color: transparent;

  @media screen and (min-width: 1024px) {
    margin-left: 16px;
  }
  @media screen and (min-width: 1280px) {
    width: 428px;
    margin-left: 32px; // 對齊指標頁圖表
  }

  :deep(.search-form) {
    position: relative;
    width: 100%;
  }

  :deep(.search-form-input) {
    display: block;
    margin: 0px auto;
    padding: 9px;
    width: 100%;
    box-sizing: border-box;
    outline: none;
    border-radius: 3px;
    appearance: none;

    color: #434343;
    background-color: #fafafa;
    box-shadow: 0px 0px 3px #e9e9e9 inset;
    border: 1px solid #dfdfdf;
    font-size: 15px;
    font-weight: bold;
    text-align: left;

    &::-webkit-search-cancel-button {
      display: none;
    }
    &::placeholder {
      color:#434343;
    }
  }
  :deep(.search-form-button) {
    display: block;
    color: #636363;
    background-color: #fafafa;
    position: absolute;
    top: 9px;
    right: 9px;
    padding-left: 6px;
    margin: 0;
    border: none;
    cursor: pointer;

    &:hover{
      color: #000;
    }
  }
}
</style>
